<template>
<section v-if="hasPermissions(['Assignment-Task Read','Assignment-Task Write', 'Assignment-Task Task-Upload'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of cleaning tasks. Clicking the Detail icon allows you to modify specifics of the task, including the Production Standard and Cleaning Steps.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="tasks.length && hasPermissions(['Assignment-Task Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <UploadOptions
                    :ref="'file_excel'"
                    :empty_format_data="empty_format_data"
                    :excel_file_headers="excel_file_headers"
                    :file_name="'task_template_file'"
                    @data="upload($event)"
                    v-if="hasPermissions(['Assignment-Task Task-Upload'])"
                />
                <UploadOptions
                    :ref="'file_excel_steps'"
                    :empty_format_data="empty_format_data_steps"
                    :excel_file_headers="excel_file_headers_steps"
                    :file_name="'steps_upload_template_file'"
                    :btn_label="'Steps Upload options'"
                    id="file_excel_input_steps"
                    @data="uploadSteps($event)"
                    v-if="hasPermissions(['Assignment-Task Task-Upload'])"
                />
                <button v-if="hasPermissions(['Assignment-Task Write'])" class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>
            
            <div v-if="hasPermissions(['Assignment-Task Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="tasks.length && hasPermissions(['Assignment-Task Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="tasks"
                                :search="search"
                                :checkable="true"
                                :link="'#'"
                                :updateable="true"
                                @emitToUpdate="modal_update($event)"
                                @emitAction="emitAction($event)"
                                ref="dinamic_table"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Task'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :array_options="array_options"
            :step_codes="step_codes"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Task Update'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            :step_codes_update="step_codes_update"
            @spliceObject="splice_object($event)"
        />

        <WaitingModal/>

        <UploadSummary
            :breadcrumb="breadcrumb"
            :summary="summary"
            :excel_file_headers="summary_file_headers"
            :excel_data="excel_data"
            :file_name="file_name_failed"
        />

        <ValidationModal 
            :breadcrumb="breadcrumb"
            :validation_table_headers="validation_table_headers"
            :validate_data="validate_data"
            message="The following tasks were not deleted because there are rooms linked to them. Please note that these rooms may also be linked to items in the recycle bin."
        />

        <HelperModal :helps="helps"/>

    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import ValidationModal      from    '@/components/ValidationModal'
import Resources            from    './resources'
import FormModal            from    './FormModal'
import UpdateModal          from    './UpdateModal'
import DeletionModal        from    '@/components/DeletionModal'
import DinamicTable         from    '@/components/DinamicTable'
import DeletionMassiveModal from    '@/components/DeletionMassiveModal'
import UploadOptions        from    '@/components/UploadOptions'
import UploadSummary        from    '@/components/UploadSummary'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import HelperModal          from    '@/components/HelperModal'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name:   'Task',

    components:{
        Breadcrumb,
        WaitingModal,
        FormModal,
        UpdateModal,
        DeletionModal,
        DinamicTable,
        DeletionMassiveModal,
        UploadOptions,
        UploadSummary,
        UnauthorizedComponent,
        ValidationModal,
        HelperModal
    },

    data(){
        return{
            notyf,
            user:               this.get_user(),
            child_href:         '/assignment-tasks/',
            title_page:         'Tasks',
            content_header:     this.$store.state.headers,
            rest_api:           `tasks`,
            notifications:      this.$store.state.form_notyf,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            validation_table_headers: Resources.validation_table_headers,
            validate_data:      [],
            add_btn:            'Add Task',
            single_select:      false,
            table_selection:    [],
            search:             '',
            global_index:       0,
            single_object:      {},
            tasks:   [],
            array_options:      {},
            step_codes:         [],
            step_codes_update:  [],
            select_ids:         [],
            summary_file_headers: [],
            excel_file_headers: Resources.excel_file_headers,
            empty_format_data:  Resources.empty_format_data,
            excel_fields_required:  Resources.excel_fields_required,
            excel_file_headers_steps: Resources.excel_file_headers_steps,
            empty_format_data_steps: Resources.empty_format_data_steps,
            summary:                [],
            excel_data:             [],
            file_name_failed: '',
            helps:              Resources.helps
        }
    },

    methods:{
        
        format_boolean(value)
        {
            let boolean_string = ''
            value ? boolean_string = 'Yes' : boolean_string = 'No'
            return boolean_string
        },

        emitAction(data)
        {
            if(data.header == 'total_rooms_record')
            {
                const task  =  this.$refs.dinamic_table.display_items[data.index]
                const radio = task.policing && !task.project ? 'policing' : task.project && !task.policing ? 'projects' : 'daily'
                const id    = task.decrypted_id;

                this.$router.push(`/building-rooms?radio=${radio}&task_id=${id}`)
            }
        },
        
        unshift_object(new_object)
        {
            this.tasks.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.tasks.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            if(!this.user.has_facility){
                notyf.error('There is not exists a facility yet')
                return false
            }
            this.step_codes.map(item => item.checked = false)
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = {...this.tasks[index]}
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index = index
            this.single_object = { ...this.tasks[index] }
            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            this.tasks = data.tasks
            this.step_codes = [...data.step_codes]
            this.step_codes_update = [...data.step_codes]
            this.array_options = {
                special_task_type: [
                     {
                        id: 2,
                        name: 'Policing',
                    },
                    {
                        id: 1,
                        name: 'Project',
                    },
                ]
            }
        },

        trashing(index)
        {
            this.tasks.splice(index, 1)
        },

        massive_modal_delete()
        {
            this.select_ids = this.tasks.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                ids:         this.select_ids,
            }

            this.loader(true)

            let response = await this.post(`${this.rest_api}/massive_delete`, json_request)

            this.loader()

            if(response)
            {
                const validation_data = response.data.validations

                console.log(validation_data);

                if(validation_data.length)
                {
                    window.$('#validations').modal('show')
                    this.validate_data = validation_data
                }

                window.$('#static-deletion-massive').modal('hide')

                response.data.deleted_ids.forEach( item =>
                {
                    const index = this.tasks.findIndex(value => value.decrypted_id == item)
                    if(index > -1)
                    {
                        this.tasks.splice(index, 1)
                    }
                })
                this.select_ids = []
            }
        },

        async upload(data)
        {
            const send_data = [];
            this.excel_data = []

            const task_type_options = [ ... this.array_options.special_task_type ]
            task_type_options.push({ name: 'Daily', id: undefined })

            for ( const value of data ) {
                const entity = {}

                for (const prop in this.excel_file_headers) {
                    entity[this.excel_file_headers[prop]] = this.parse_boolean(value[prop])
                }

                this.excel_data.push({... entity})
                
                const task_type = task_type_options.find(item => item.name == entity.special_task_type)
                entity.special_task_type = task_type ? task_type.id : undefined

                if(entity.special_task_type === undefined)
                {
                    entity.project = false
                    entity.policing = false
                }
                else if(entity.special_task_type === 1)
                {
                    entity.project = true
                    entity.policing = false
                }
                else if(entity.special_task_type === 2)
                {
                    entity.project = false
                    entity.policing = true
                }

                send_data.push(entity)
            }

            this.loader(true)
            const response = await this.post(`${this.rest_api}/massive`, { tasks: send_data })
            this.loader()

            if(response.status)
            {
                notyf.success('Success!')
                this.summary_file_headers = Resources.excel_file_headers_tasks
                this.file_name_failed = 'tasks_failed_template_file'
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')
                
                for (const task of response.data.tasks) {
                    this.unshift_object(task);
                }
            }
            else
            {
                this.error_handling(response)
            }

            this.$refs.file_excel.clear_data()
        },

        async uploadSteps(data)
        {
            this.excel_data = data

            this.loader(true)
            const response = await this.post(`${this.rest_api}/massive_steps`, { steps: data, timestamp: this.getCurrentDateTime() })
            this.loader()

            if(response.status)
            {
                if(response.data.is_queue)
                {
                    notyf.success('Given you are uploading many records, you will get notified when the upload process is finished.')
                    return;
                }

                notyf.success('Success!')
                this.summary_file_headers = Resources.excel_file_headers_steps
                this.file_name_failed = 'task_steps_failed_template_file'
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')
                this.getInitialData()
            }
            else
            {
                this.error_handling(response)
            }

            this.$refs.file_excel_steps.clear_data()

        },
        
        async getInitialData()
        {
            if(this.hasPermissions(['Assignment-Task Read','Assignment-Task Write', 'Assignment-Task Task-Upload']))
            {
                await this.api_request()
            }
        }

    },

    async mounted(){
        this.getInitialData()
    },

    computed:
    {
        selected()
        {
            const bool = this.tasks.filter(item => item.checked)
            return Boolean(bool.length)
        }
    }
}
</script>